import React, { useState } from 'react';
import { ButtonGroup, Button } from '../ui-kit';
import * as Sentry from '@sentry/browser';
import ErrorBoundary from '../general/ErrorBoundary';

const Errors = () => {
  const [show, setShow] = useState(false);
  const sayHello = () => {
    Sentry.captureMessage('Hello world!');
  };

  const UncaughtError = () => {
    throw new Error('Oh no');
  };

  return (
    <div>
      <br />
      <ButtonGroup>
        <Button variant="primary" onClick={sayHello}>
          {' '}
          Hello Sentry{' '}
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            setShow(!show);
          }}
        >
          {' '}
          Oh no!
        </Button>
      </ButtonGroup>

      {show ? (
        <ErrorBoundary>
          <UncaughtError />
        </ErrorBoundary>
      ) : null}
    </div>
  );
};

export default Errors;
